/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CorporateStructureLink'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CorporateStructureLink'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.IntegrationFinancialUploadBatchExcelFile = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CorporateStructureLink);
  }
}(this, function(ApiClient, CorporateStructureLink) {
  'use strict';




  /**
   * The IntegrationFinancialUploadBatchExcelFile model module.
   * @module model/IntegrationFinancialUploadBatchExcelFile
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>IntegrationFinancialUploadBatchExcelFile</code>.
   * @alias module:model/IntegrationFinancialUploadBatchExcelFile
   * @class
   */
  var exports = function() {
    var _this = this;

















  };

  /**
   * Constructs a <code>IntegrationFinancialUploadBatchExcelFile</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationFinancialUploadBatchExcelFile} obj Optional instance to populate.
   * @return {module:model/IntegrationFinancialUploadBatchExcelFile} The populated <code>IntegrationFinancialUploadBatchExcelFile</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('BatchFileID')) {
        obj['BatchFileID'] = ApiClient.convertToType(data['BatchFileID'], 'Integer');
      }
      if (data.hasOwnProperty('SheetName')) {
        obj['SheetName'] = ApiClient.convertToType(data['SheetName'], 'String');
      }
      if (data.hasOwnProperty('DateRow')) {
        obj['DateRow'] = ApiClient.convertToType(data['DateRow'], 'Integer');
      }
      if (data.hasOwnProperty('DataStartCell')) {
        obj['DataStartCell'] = ApiClient.convertToType(data['DataStartCell'], 'String');
      }
      if (data.hasOwnProperty('DimensionID')) {
        obj['DimensionID'] = ApiClient.convertToType(data['DimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('PeriodTypeID')) {
        obj['PeriodTypeID'] = ApiClient.convertToType(data['PeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('NegativeExpenses')) {
        obj['NegativeExpenses'] = ApiClient.convertToType(data['NegativeExpenses'], 'Boolean');
      }
      if (data.hasOwnProperty('DynamicTrackingLevelID')) {
        obj['DynamicTrackingLevelID'] = ApiClient.convertToType(data['DynamicTrackingLevelID'], 'Integer');
      }
      if (data.hasOwnProperty('DynamicTrackingLevelColumn')) {
        obj['DynamicTrackingLevelColumn'] = ApiClient.convertToType(data['DynamicTrackingLevelColumn'], 'String');
      }
      if (data.hasOwnProperty('CorporateStructureLink')) {
        obj['CorporateStructureLink'] = CorporateStructureLink.constructFromObject(data['CorporateStructureLink']);
      }
      if (data.hasOwnProperty('FirstColumnAccountNumbers')) {
        obj['FirstColumnAccountNumbers'] = ApiClient.convertToType(data['FirstColumnAccountNumbers'], 'Boolean');
      }
      if (data.hasOwnProperty('CurrencyRateConversion')) {
        obj['CurrencyRateConversion'] = ApiClient.convertToType(data['CurrencyRateConversion'], 'Number');
      }
      if (data.hasOwnProperty('YearToDateValues')) {
        obj['YearToDateValues'] = ApiClient.convertToType(data['YearToDateValues'], 'Boolean');
      }
      if (data.hasOwnProperty('BalanceSheetConversionRate')) {
        obj['BalanceSheetConversionRate'] = ApiClient.convertToType(data['BalanceSheetConversionRate'], 'Number');
      }
      if (data.hasOwnProperty('ImportAccountingDataEntries')) {
        obj['ImportAccountingDataEntries'] = ApiClient.convertToType(data['ImportAccountingDataEntries'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} BatchFileID
   * @default 0
   */
  exports.prototype['BatchFileID'] = 0;
  /**
   * @member {String} SheetName
   * @default ''
   */
  exports.prototype['SheetName'] = '';
  /**
   * @member {Integer} DateRow
   * @default 0
   */
  exports.prototype['DateRow'] = 0;
  /**
   * @member {String} DataStartCell
   * @default ''
   */
  exports.prototype['DataStartCell'] = '';
  /**
   * @member {Integer} DimensionID
   * @default 0
   */
  exports.prototype['DimensionID'] = 0;
  /**
   * @member {Integer} PeriodTypeID
   * @default 0
   */
  exports.prototype['PeriodTypeID'] = 0;
  /**
   * @member {Boolean} NegativeExpenses
   * @default false
   */
  exports.prototype['NegativeExpenses'] = false;
  /**
   * @member {Integer} DynamicTrackingLevelID
   */
  exports.prototype['DynamicTrackingLevelID'] = undefined;
  /**
   * @member {String} DynamicTrackingLevelColumn
   * @default ''
   */
  exports.prototype['DynamicTrackingLevelColumn'] = '';
  /**
   * @member {module:model/CorporateStructureLink} CorporateStructureLink
   */
  exports.prototype['CorporateStructureLink'] = undefined;
  /**
   * @member {Boolean} FirstColumnAccountNumbers
   * @default false
   */
  exports.prototype['FirstColumnAccountNumbers'] = false;
  /**
   * @member {Number} CurrencyRateConversion
   */
  exports.prototype['CurrencyRateConversion'] = undefined;
  /**
   * @member {Boolean} YearToDateValues
   * @default false
   */
  exports.prototype['YearToDateValues'] = false;
  /**
   * @member {Number} BalanceSheetConversionRate
   */
  exports.prototype['BalanceSheetConversionRate'] = undefined;
  /**
   * @member {Boolean} ImportAccountingDataEntries
   * @default false
   */
  exports.prototype['ImportAccountingDataEntries'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


